import React, { useState } from 'react'
import Scroll from 'react-scroll'
import PosterFormatItem from '../../PosterFormatItem'
import BackgroundFormatItemContainer from '../../BackgroundFormatItem'

let Element = Scroll.Element

const GridItemSingle = ({
    itemId, 
    index,
    itemData,
    itemOnClick, 
    hasGridHoverTrailer,
    onOpenPerformancePage,
    isMobile,
    dayFilters,
    showPerformances,
    theme,
    styles,
    overviewFilterIgnoreOnPerformances,
    isSlider,
    queryStringValues,
    additionalScrollName,
    isConnectedFast, 
    translation,
}) => {
    const [isHover, setIsHover] = useState(false)

    return (
        <div className="order-wrapper" style={styles} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
            <Element name={itemId + additionalScrollName}></Element>

            {theme === 'Arthouse' ? 
                isMobile && !isSlider ? (
                    <PosterFormatItem
                        itemID={itemId}
                        itemData={itemData}
                        showPerformances={true}
                        translation={translation}
                        scrollToPosition={itemId + additionalScrollName}
                        isMobile={isMobile}
                        onClickItem={itemOnClick}
                        showAttributes={true}
                        index = {index}
                        showFSK={true}
                        overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                        dayFilters={dayFilters}    
                        queryStringValues={queryStringValues}
                        onOpenPerformancePage={onOpenPerformancePage}
                        theme={theme}
                        isOverview={false}
                        shouldPlayTrailer={hasGridHoverTrailer && isHover}
                        isConnectedFast={isConnectedFast}
                    />
                ) : (
                    <div key={index} className="slide-item">
                        <BackgroundFormatItemContainer
                            itemID={itemId}
                            itemData={itemData}
                            dayFilters={dayFilters}
                            queryStringValues={queryStringValues}
                            overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                            showPerformances={true}
                            translation={translation}
                            scrollToPosition={itemId + additionalScrollName}
                            isMobile={isMobile}
                            onClickItem={itemOnClick}
                            index = {index}
                            onOpenPerformancePage={onOpenPerformancePage}
                        />
                    </div>
            ) : (
                <PosterFormatItem
                    itemID={itemId}
                    showAttributes={true}
                    onOpenPerformancePage={onOpenPerformancePage}
                    index = {index}
                    queryStringValues={queryStringValues}
                    isMobile={isMobile}
                    showPerformances={showPerformances}
                    showFSK={true}
                    overviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                    itemData={itemData}
                    dayFilters={dayFilters}
                    isOverview={false}
                    scrollToPosition={itemId + additionalScrollName}
                    onClickItem={itemOnClick}
                    translation={translation}
                    shouldPlayTrailer={hasGridHoverTrailer && isHover}
                    isConnectedFast={isConnectedFast}
                />
            )}

            <Element name={itemId + additionalScrollName + ' openMovieInformation'}></Element>
        </div>
    )
}

export default GridItemSingle